import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Result, Button } from 'antd';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "handleRetry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ hasError: false, error: undefined });
                this.props.onRetry?.();
            }
        });
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught error:', error, info);
    }
    render() {
        if (this.state.hasError) {
            return (_jsx(Result, { status: "error", title: "Something went wrong", subTitle: this.state.error?.message ?? 'An unexpected error occurred.', extra: _jsx(Button, { type: "primary", onClick: this.handleRetry, children: "Try Again" }) }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map